import { Routes, Route } from "react-router-dom";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import { useEffect } from "react";

import Contents from "./pages/Contents";
import Admin from "./pages/Admin";
import LP from "./pages/LP";
import "bootstrap/dist/css/bootstrap.min.css";
import Contact from "./pages/Contact";

const App = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.initialize(process.env.REACT_APP_GA4_MEASUREMENT_ID || "");
  }, []);

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);

  return (
    <Routes>
      <Route path="/" element={<Contents />} />
      <Route path="/admin/*" element={<Admin />} />
      <Route path="/lp" element={<LP />} />
      <Route path="/contact" element={<Contact />} />
    </Routes>
  );
};

export default App;
